import React, { FC, MouseEventHandler } from 'react'
import { CarIcon } from './types'
import { TransferSearchResult } from '../../hooks/useTransfers/types'
import pluralize from 'pluralize'
import { formatCurrency } from '../../common'
import { carIconToComponent } from './index'

export interface Props {
  icon: CarIcon
  title: string
  description?: string
  results: TransferSearchResult[]
  minPrice: number
  maxPrice: number
  onSelected?: (icon: CarIcon, title: string, results: TransferSearchResult[]) => void
}

const TransferSearchResultGroupListItem: FC<Props> = ({ icon, title, minPrice, results, onSelected }) => {
  const Icon = carIconToComponent(icon)

  const onClick: MouseEventHandler = (e) => {
    e.preventDefault()
    onSelected?.(icon, title, results)
  }

  return (
    <div className="transfer-search-result-group" onClick={onClick}>
      <div className="transfer-search-result-group__icon">
        <Icon />
      </div>
      <div className="transfer-search-result-group__content">
        <p className="transfer-search-result-group__title">{title}</p>
        <p className="transfer-search-result-group__subtitle">
          {`${results.length} ${pluralize('option', results.length)} available`}
        </p>
      </div>
      <div className="transfer-search-result-group__pricing">
        from
        <span className="transfer-search-result-group__pricing__price">£{formatCurrency(minPrice)}</span>
      </div>
    </div>
  )
}

export default TransferSearchResultGroupListItem
